import { render, staticRenderFns } from "./DistributionBarVT.vue?vue&type=template&id=34bb29be&scoped=true"
import script from "./DistributionBarVT.vue?vue&type=script&lang=js"
export * from "./DistributionBarVT.vue?vue&type=script&lang=js"
import style0 from "./DistributionBarVT.vue?vue&type=style&index=0&id=34bb29be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bb29be",
  null
  
)

export default component.exports